var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"fm-btn",class:_vm.btnClass,attrs:{"href":_vm.href},on:{"click":function($event){$event.stopPropagation();return _vm.clickBtn.apply(null, arguments)}}},[_c('div',{staticClass:"fm-btn-wrap"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }